export default __webpack_public_path__ + "static/media/image09.805b304a.jpg";